import { put, fork, all, cancel, take } from "redux-saga/effects";

import { WATCHERS } from "../actions/actionConstants.js";
import { AUTHENTICATION } from "../reducers/authentication/authenticationConstants.js";

import { createAction } from "../actions/actionUtils.js";

import { watchStartupSagas } from "./startupSagas.js";
import { watchCoreDataSagas } from "./coreDataSagas.js";
import { watchOperationSagas } from "./operationSagas.js";
import { watchDataRequestSagas } from "./apiSagas.js";
import { watchProjectSagas } from "./projectSagas.js";
import { watchConnectionSagas } from "./connectionSagas.js";
import { watchProjectWizardSagas } from "./projectWizardSagas.js";
import { watchInviteSagas } from "./inviteSagas.js";
import { watchUsageSagas } from "./usageSagas.js";
import { watchResourceSagas } from "./resourceSagas.js";
import { watchScheduleSagas } from "./scheduleSagas.js";
import { watchInvoiceSagas } from "./invoiceSagas.js";
import { watchUserSagas } from "./userSagas.js";
import { watchSignUpSagas } from "./signUpSagas.js";
import { watchVerifySagas } from "./verifySagas.js";
import { watchEstimateSagas } from "./estimateSaga.js";
import { watchAccountSagas } from "./accountSagas.js";
import { watchEntitiesSagas } from "./entitySagas.js";
import { watchFederatedLogin } from "./federatedAuthenticationSagas.js";

// import { watchHelpWidgetSagas } from "./helpWidgetSagas.js";
import { watchDownloadSagas } from "./downloadSagas.js";

// -- ROOT WATCHERS -- //

// the cancel functionality here is a bit of a blunt instrument
// needs refactoring at a later date
export default function* root() {
  yield all([
    fork(watchStartupSagas),
    fork(watchDataRequestSagas),
    fork(watchOperationSagas),
    fork(watchFederatedLogin)
  ]);

  // watchers that can be reset during SPA lifespan
  while (true) {
    const watchers = yield all([
      fork(watchCoreDataSagas),
      fork(watchAccountSagas),
      // fork(watchHelpWidgetSagas),
      fork(watchProjectSagas),
      fork(watchConnectionSagas),
      fork(watchProjectWizardSagas),
      fork(watchInviteSagas),
      fork(watchEstimateSagas),
      fork(watchUsageSagas),
      fork(watchResourceSagas),
      fork(watchUserSagas),
      fork(watchSignUpSagas),
      fork(watchVerifySagas),
      fork(watchScheduleSagas),
      fork(watchInvoiceSagas),
      fork(watchDownloadSagas),
      fork(watchEntitiesSagas)
    ]);

    // this flag is needed so that resets play well with <RedirectWithReset /> and <LinkWithReset />
    // it's maybe not the most elegant solution but works for now until I can perform a more thorough saga structure review
    yield put(createAction(WATCHERS.READY));

    yield take([WATCHERS.RESET, AUTHENTICATION.LOGOUT.DO]); // make sure that all in progress calls are cancelled when logging out
    yield cancel([...watchers]);
  }
}
